<template>
  <svg ref="barcode" class="noicon">
  </svg>
</template>

<script>
import { findBarcodeType } from '@/utils/barcodes';
import CONSTANTS from '@/constants/constants';

export default {
  name: 'Barcode',

  props: {
    value: { type: Number, required: true },
  },

  computed: {
    barcode() {
      // EAN and UPC have the last number computed,
      // which we should take out before we pass it to the library
      const appendedTypes = [CONSTANTS.barcodeTypes.EAN.value, CONSTANTS.barcodeTypes.UPC.value];
      if (appendedTypes.includes(this.type)) {
        const numberString = `${this.value}`;
        const length = numberString.length;
        return numberString.substring(0, length - 1);
      }
      return this.value;
    },

    type() {
      return findBarcodeType(this.value).jsBarcodeType;
    },
  },

  mounted() {
    window.JsBarcode(this.$refs.barcode, `${this.barcode}`, { format: this.type });
  },
};
</script>
